export default "__VITE_ASSET__lHRTRTgv__"